import {observer} from "mobx-react-lite"
import { FC, ReactElement, useContext, useEffect } from "react"
import {Context} from "../.."

import styles from "./BottomModal.module.scss"

interface BottomModalProps {
  prePreVisible: boolean
  preVisible: boolean
  visible: boolean
  onClose: () => void
  content: ReactElement | string
  title: string
}

const BottomModal: FC<BottomModalProps> = ({
  preVisible, prePreVisible, visible, onClose, content, title
}) => {

  const { store } = useContext(Context)

  const onTouchStart = (ev: any) => {
    console.log("START", ev)
    store.setBottomPlusSt(ev.touches[0].clientY)
  }

  const onTouchMove = (ev: any) => {
    console.log("MOVE", ev)
    console.log(store.bottomPlusSt, ev.touches[0].clientY)
    store.setBottomPlus(ev.touches[0].clientY - store.bottomPlusSt)
  }

  const onTouchEnd = (ev: any) => {
    if (store.bottomPlus > 200) {
      onClose()
      store.setBottomPlus(0)
    } else {
      store.setBottomPlus(0)
    }
  }

  if (!prePreVisible) return null

  return (
    <>
      <div 
        className={styles.bottom_action_modal} 
        id="btm_modal" 
        style={{opacity: preVisible ? "1" : "0"}}
        onClick={() => onClose()}
        onTouchMove={(ev) => {
          // console.log(ev)
        }}>
        <div className={styles.bam_dialog} style={{
          bottom: visible ? `${store.bottomPlus == 0 ? "0" : `-${store.bottomPlus}`}px` : "-100px",
          opacity: visible ? "1" : "0"
        }} onClick={(evt) => {
          evt.preventDefault()
          evt.stopPropagation()
        }} onTouchEnd={(ev) => onTouchEnd(ev)} onTouchStart={(ev) => onTouchStart(ev)} onTouchMove={(ev) => onTouchMove(ev)}>
          <div className={styles.bam_header}>
            <div className={styles.bam_line} onClick={() => onClose()}></div>
            <div className={styles.bam_title}>{title}</div>
          </div>
          <div className={styles.bam_body}>{content}</div>
        </div>
      </div>
    </>
  )
}

export default observer(BottomModal)